// Vendor
import 'svgxuse';

// Legacy vanilla scripts (non-jQuery parts of main-script.js)
import './legacy';

// Modules
import ModuleLoader from './utils/moduleLoader';

class App {
	constructor () {
		this.loader = new ModuleLoader({

		});
	}

	render () {
		this.loader.load();

		return this;
	}
}

window.app = new App().render(); 
